import { Text, ThemingContext } from '@doordash/design-language';
import PropTypes from 'prop-types';
import React from 'react';
import { TitleTextContainer } from '../styles';
import get from 'lodash.get';

var HeaderText = function HeaderText(_ref) {
  var headerAlignment = _ref.headerAlignment,
      subtitle = _ref.subtitle,
      title = _ref.title,
      titleSize = _ref.titleSize,
      subtitleSize = _ref.subtitleSize;
  var theme = React.useContext(ThemingContext);
  return React.createElement(React.Fragment, null, React.createElement(TitleTextContainer, {
    shouldCenterText: headerAlignment === Text.TextAlignments.Center
  }, React.createElement(Text, {
    tag: "h2",
    styles: Text.Styles.MajorPageTitle,
    size: titleSize || get(theme, 'Modal.titleSize')
  }, title)), subtitle && subtitle.length && React.createElement(Text, {
    textAlign: headerAlignment,
    styles: Text.Styles.PageSubtext,
    size: subtitleSize
  }, subtitle));
};

HeaderText.propTypes = {
  headerAlignment: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.node,
  titleSize: PropTypes.number,
  subtitleSize: PropTypes.number
};
export default HeaderText;